import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { createPortal } from "react-dom";

interface Props {
    value: Date | null;
    onChange: (date: Date | null) => void;
}


export const PopperPortal = ({ children }: { children: React.ReactNode }) => {
    return createPortal(children, document.body);
};


const CustomDatePicker: React.FC<Props> = ({ value, onChange }) => {
    return (
        <DatePicker
            selected={value}
            onChange={(date) => onChange(date)}
            dateFormat="dd/MM/yyyy"
            placeholderText="Select date"
            className="form-control w-100"
            popperContainer={({ children }) => <PopperPortal>{children}</PopperPortal>}
            popperPlacement="bottom-start"
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            scrollableYearDropdown
            yearDropdownItemNumber={120}
        />
    );
};

export default CustomDatePicker;
